(()=>{
  const ready=()=>{
    const html=document.documentElement;
    const main=document.getElementById('MainContent');
    if(!main)return;

    const reduced=window.matchMedia?window.matchMedia('(prefers-reduced-motion: reduce)'):null;
    const isReduced=()=>!!(reduced&&reduced.matches);
    const preparedTargets=new WeakSet();
    const preparedShells=new WeakSet();
    const targets=new Set();
    const pending=new Set();
    let io=null;
    let scanRaf=0;
    let observing=false;

    const reveal=el=>{
      if(!el)return;
      el.classList.add('ecz56-in');
      pending.delete(el);
      if(io)io.unobserve(el);
    };

    const groupFor=el=>el.closest('.eczgm2-hero,.eczgm2-pagehero,.ecz53-trusthero,.eczgm2-section,.eczgm2-final,section.eczgm2,.shopify-section');

    const mark=(el,type)=>{
      if(!el||preparedTargets.has(el)||el.closest('header,footer,[data-ecz52-quick],[data-ecz52-sequence]'))return;
      if(!main.contains(el))return;
      el.setAttribute('data-ecz56-reveal',type);
      preparedTargets.add(el);
      targets.add(el);
    };

    const applyDelays=scope=>{
      const groupMap=new Map();
      [...scope.querySelectorAll('[data-ecz56-reveal]')].forEach(el=>{
        const group=groupFor(el)||main;
        if(!groupMap.has(group))groupMap.set(group,[]);
        groupMap.get(group).push(el);
      });
      groupMap.forEach(list=>{
        let general=0,chain=0,micro=0,object=0;
        list.forEach(el=>{
          const type=el.getAttribute('data-ecz56-reveal');
          let delay=0;
          if(type==='chain')delay=Math.min(40+(chain++*42),250);
          else if(type==='micro')delay=Math.min(35+(micro++*48),220);
          else if(type==='object')delay=Math.min(35+(object++*58),260);
          else delay=Math.min(general++*62,220);
          el.style.setProperty('--ecz56-delay',`${delay}ms`);
        });
      });
    };

    const prepareScope=(scope=main)=>{
      const base=scope===document?main:scope;
      if(!base)return;
      const objectSelectors=[
        '.ecz52-passport','.ecz53-freecard','.eczgm2-jobs article','.eczgm2-boundary article',
        '.eczgm2-intent article','.eczgm2-card','.eczgm2-products article','.eczgm2-stakeholders a',
        '.ecz52-routeblock','.ecz52-boundary5 article','.ecz52-story','.ecz52-tier',
        '.ecz52-providergrid article','.eczgm2-route','.eczgm2-proof__grid','.ecz53-proofcard',
        '.product__media-wrapper','.product__info-wrapper','.related-products .card-wrapper',
        '.collection .card-wrapper','.product-grid .card-wrapper'
      ].join(',');
      base.querySelectorAll(objectSelectors).forEach(el=>mark(el,'object'));

      const addText=(selector,type)=>base.querySelectorAll(selector).forEach(el=>{
        if(el.closest('[data-ecz56-reveal="object"]'))return;
        mark(el,type);
      });
      addText('.eczgm2-eyebrow','eyebrow');
      addText('h1,h2','heading');
      addText('.eczgm2-lead,.ecz53-free__lead,.eczgm2-head > p,.eczgm2-two > div > p,.eczgm2-pagehero .eczgm2-shell > p,.ecz53-trusthero__support','text');
      addText('.eczgm2-mnemonic > span,.ecz52-flowline > span','micro');
      addText('.ecz52-chain > li','chain');
      addText('.eczgm2-id,.ecz52-proofjson,.ecz53-proofcard__id,.ecz53-proofcard__state','proof');
      applyDelays(base);

      base.querySelectorAll('.shopify-section').forEach(section=>{
        if(preparedShells.has(section)||section.closest('header,footer'))return;
        preparedShells.add(section);
        if(section.querySelector('[data-ecz56-reveal]'))return;
        if(!section.querySelector('h1,h2,.product,.collection,.cart-items,.template-search,.article-template'))return;
        section.setAttribute('data-ecz56-shell','');
        targets.add(section);
      });
    };

    const updatePreference=()=>{
      html.dataset.eczMotionPreference=isReduced()?'reduced':'full';
    };

    const scan=()=>{
      scanRaf=0;
      const vh=window.innerHeight||document.documentElement.clientHeight||800;
      pending.forEach(el=>{
        const r=el.getBoundingClientRect();
        if(r.top<vh*.90&&r.bottom>Math.max(0,vh*.015))reveal(el);
      });
    };
    const scheduleScan=()=>{if(!scanRaf)scanRaf=requestAnimationFrame(scan)};

    const observePending=()=>{
      if(observing)return;
      observing=true;
      if('IntersectionObserver' in window){
        io=new IntersectionObserver(entries=>entries.forEach(entry=>{
          if(entry.isIntersecting)reveal(entry.target);
        }),{threshold:.08,rootMargin:'0px 0px -9% 0px'});
        pending.forEach(el=>io.observe(el));
      }
      requestAnimationFrame(scan);
    };

    try{
      prepareScope(main);
      if(targets.size){
        html.classList.add('ecz56-motion-ready');
        html.dataset.eczMotion='v4-targets';
        updatePreference();
        targets.forEach(el=>pending.add(el));

        window.addEventListener('scroll',scheduleScan,{passive:true});
        document.addEventListener('scroll',scheduleScan,{passive:true,capture:true});
        window.addEventListener('resize',scheduleScan,{passive:true});
        window.addEventListener('keydown',event=>{
          if(['ArrowDown','ArrowUp','PageDown','PageUp','Home','End',' '].includes(event.key))scheduleScan();
        },{passive:true});

        /* Paint the pre-entry state first, then arm both observer and scroll/keyboard fallback. */
        requestAnimationFrame(()=>requestAnimationFrame(observePending));
      }

      const revealHash=()=>{
        if(!location.hash||location.hash.length<2)return;
        let id='';
        try{id=decodeURIComponent(location.hash.slice(1))}catch(_){id=location.hash.slice(1)}
        const anchor=document.getElementById(id);
        if(!anchor)return;
        const own=anchor.matches?.('[data-ecz56-reveal],[data-ecz56-shell]')?anchor:anchor.closest?.('[data-ecz56-reveal],[data-ecz56-shell]');
        if(own)reveal(own);
        anchor.querySelectorAll?.('[data-ecz56-reveal],[data-ecz56-shell]').forEach(reveal);
      };
      revealHash();
      window.addEventListener('hashchange',revealHash,{passive:true});
      document.addEventListener('focusin',event=>{
        const el=event.target&&event.target.closest&&event.target.closest('[data-ecz56-reveal],[data-ecz56-shell]');
        if(el)reveal(el);
      },true);

      document.addEventListener('shopify:section:load',event=>{
        const before=new Set(targets);
        prepareScope(event.target);
        targets.forEach(el=>{
          if(before.has(el)||el.classList.contains('ecz56-in'))return;
          pending.add(el);
          if(io)io.observe(el);
        });
        scheduleScan();
      });

      /* Preserve the accepted right-hand hero sequence. This fallback only supplies its reduced-motion state changes. */
      const seq=document.querySelector('[data-ecz52-sequence]');
      const softSteps=seq?[...seq.querySelectorAll('[data-ecz52-step]')]:[];
      let softTimer=0;
      let softIndex=-1;
      const clearSoft=()=>{
        if(softTimer){clearTimeout(softTimer);softTimer=0}
        softSteps.forEach(step=>step.classList.remove('ecz56-soft-active'));
        softIndex=-1;
      };
      const softTick=()=>{
        if(!isReduced()||!softSteps.length){clearSoft();return}
        softIndex=(softIndex+1)%softSteps.length;
        softSteps.forEach((step,i)=>step.classList.toggle('ecz56-soft-active',i===softIndex));
        softTimer=setTimeout(softTick,2100);
      };
      const syncSoft=()=>{
        clearSoft();
        updatePreference();
        if(isReduced()&&softSteps.length)softTimer=setTimeout(softTick,500);
      };
      syncSoft();
      if(reduced){
        if(reduced.addEventListener)reduced.addEventListener('change',syncSoft);
        else if(reduced.addListener)reduced.addListener(syncSoft);
      }
    }catch(_){
      html.classList.remove('ecz56-motion-ready');
      html.dataset.eczMotion='failed-open';
    }

    /* Footer-aware compact utility docking — preserved from the accepted V2 fix. */
    const dock=document.querySelector('[data-ecz52-quick]');
    const footer=document.querySelector('[data-ecz54-footer]');
    const machine=footer&&footer.querySelector('.eczgm2-footer__machine');
    if(dock&&footer){
      let dockRaf=0;
      const base=()=>12;
      const positionDock=()=>{
        dockRaf=0;
        const vh=window.innerHeight||document.documentElement.clientHeight||800;
        const fr=footer.getBoundingClientRect();
        dock.classList.remove('ecz56-footer-docked');
        if(machine){
          const mr=machine.getBoundingClientRect();
          if(mr.top<vh&&mr.bottom>0){
            const qh=Math.max(1,dock.getBoundingClientRect().height);
            const desiredTop=mr.top+Math.max(4,(mr.height-qh)/2);
            const bottom=Math.max(base(),vh-(desiredTop+qh));
            dock.style.setProperty('--ecz55-dock-bottom',`${Math.round(bottom)}px`);
            dock.classList.add('ecz56-footer-docked');
            dock.dataset.eczDock='machine-row';
            return;
          }
        }
        if(fr.top<vh&&fr.bottom>0){
          const overlap=Math.max(0,vh-fr.top);
          dock.style.setProperty('--ecz55-dock-bottom',`${Math.round(base()+overlap)}px`);
          dock.dataset.eczDock='footer-clear';
        }else{
          dock.style.setProperty('--ecz55-dock-bottom',`${base()}px`);
          dock.dataset.eczDock='viewport';
        }
      };
      const scheduleDock=()=>{if(!dockRaf)dockRaf=requestAnimationFrame(positionDock)};
      window.addEventListener('scroll',scheduleDock,{passive:true});
      window.addEventListener('resize',scheduleDock,{passive:true});
      if('ResizeObserver' in window){
        const ro=new ResizeObserver(scheduleDock);
        ro.observe(footer);
        if(machine)ro.observe(machine);
        ro.observe(dock);
      }
      scheduleDock();
    }
  };
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',ready,{once:true}):ready();
})();
